import React from 'react';
import { Button } from 'react-bootstrap';
import { ICON_REMOVE, ICON_EDIT } from '../../extras/icons';
//Función principal
const VictimInfoForm = props => {
    //Tomo los props
    const { index, victim, handleEdit, handleRemove } = props;
    //Renderizo
    return (
        <div className="col-12">
            <div className="card mb-2 border-info">
                <div className="card-header">
                    <strong>VICTIMA #{index + 1}</strong>
                    {
                        handleRemove ? (
                            <Button variant="danger" size="sm" className="float-right ml-2" onClick={() => handleRemove(victim)}>
                                <ICON_REMOVE />
                            </Button>
                        ) : null
                    }
                    {
                        handleEdit ? (
                            <Button variant="info" size="sm" className="float-right ml-2" onClick={() => handleEdit(victim)}>
                                <ICON_EDIT />
                            </Button>
                        ) : null
                    }
                </div>
                <div className="card-body">
                    <div className="h6 mb-0 font-weight-bold text-gray-800">
                        <div className="row">
                            <div className="col-md-6 mb-1">
                                <small>APELLIDO Y NOMBRE:</small>
                                <br/>
                                { `${victim.persona.apellido}, ${victim.persona.nombre}` }
                            </div>
                            <div className="col-md-3 mb-1">
                                <small>TIPO Y NÚMERO DOC.:</small>
                                <br/>
                                {
                                    victim.persona.tipo_documento && victim.persona.nro_documento ? (
                                        `${victim.persona.tipo_documento}: ${victim.persona.nro_documento}`
                                    ) : null
                                }
                            </div>
                            <div className="col-md-3 mb-1">
                                <small>ES MENOR?:</small>
                                <br/>
                                { victim.menor === '1' ? 'SI' : 'NO' }
                            </div>
                            <div className="col-md-6 mb-1">
                                <small>DOMICILIO:</small>
                                <br/>
                                { victim.domicilio }
                            </div>
                            <div className="col-md-3 mb-1">
                                <small>TELÉFONO:</small>
                                <br/>
                                { victim.telefono ? victim.telefono : 'N/D' }
                            </div>
                            <div className="col-md-3 mb-1">
                                <small>EMAIL:</small>
                                <br/>
                                { victim.email ? victim.email : 'N/D' }
                            </div>
                            <div className="col-md-3 mb-1">
                                <small>ES QUERELLANTE?:</small>
                                <br/>
                                { victim.querellante === '1' ? 'SI' : 'NO' }
                            </div>
                            <div className="col-md-6 mb-1">
                                <small>DEFENSA PÚBLICA:</small>
                                <br/>
                                {
                                    victim.defensoria ? (
                                        `${victim.defensoria.descripcion}`
                                    ) : null
                                }
                            </div>
                            {
                                victim.particular && victim.particular.length ? (
                                    <div className="col-12 mb-1">
                                        <table className="table table-bordered table-sm">
                                            <thead>
                                                <tr className="table-light">
                                                    <th colSpan="3" className="align-middle text-center">
                                                        DEFENSORES PARTICULARES
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th className="text-center">Apellido y Nombre</th>
                                                    <th className="text-center">Email</th>
                                                    <th className="text-center">Teléfono</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    victim.particular.map(p => (
                                                        <tr>
                                                            <td className="align-middle">
                                                                { p.persona.apellido + ', ' + p.persona.nombre }
                                                            </td>
                                                            <td className="align-middle text-center">
                                                                { p.email }
                                                            </td>
                                                            <td className="align-middletext-center">
                                                                { p.telefono }
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                ) : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VictimInfoForm;